export default __webpack_public_path__ + "static/media/web-building.549121de.png";